export default "__VITE_ASSET__BxjmP2Lv__"